import React, { useState } from "react";
import PropTypes from "prop-types";
import { HintModal } from "./HintModal";
import { HintButton } from "./HintButton";
import { HintButtonInfo } from "./HintButtonInfo";

import "./style.scss";

export function Hint(props) {
  const [hintModalHidden, setHintModalHidden] = useState(true);

  const openHintModal = () => {
    setHintModalHidden(false);
  };

  const closeHintModal = () => {
    setHintModalHidden(true);
  };

  const onClickYes = () => {
    if (props.hintsLeft) {
      props.useHint();
      closeHintModal();
    }
  };

  const onClickNo = () => {
    closeHintModal();
  };
  const className = `hintButton ${props.className}`;
  return (
    <>
      <HintButton
        className={className}
        tabIndex={props.tabIndex}
        onClick={openHintModal}
      >
        <HintButtonInfo
          className="hintButton__info "
          tabIndex={props.tabIndex}
          hintsLeft={props.hintsLeft}
          totalHints={props.totalHints}
        />
      </HintButton>
      <HintModal
        className="hintModal"
        tabIndex={props.tabIndex}
        isOpen={!hintModalHidden}
        hintsLeft={props.hintsLeft}
        message={props.message}
        onClickYes={onClickYes}
        onClickNo={onClickNo}
      />
    </>
  );
}

Hint.propTypes = {
  /**
   * classname for custom style of component
   */
  className: PropTypes.string,
  /**
   * Callback for when user choose to use a hint
   */
  useHint: PropTypes.func,
  /**
   * Number of hints left
   */
  hintsLeft: PropTypes.number,
  /**
   * total number of hints available
   */
  totalHints: PropTypes.number,
  /**
   * Message to be displayed on Hints Modal
   */
  message: PropTypes.string,
  /**
   * for keyboard accessibility
   */
  tabIndex: PropTypes.number,
};

Hint.defaultProps = {
  className: "",
};
